import { Component, OnInit, Inject, inject, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA , MatDialogModule} from '@angular/material/dialog';
import { TeamService } from '../../services/team.service';
import { TeamVariant, ModelVariant } from '../../../shared/models/type-list';
import { FormGroup, FormBuilder, FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule, MatSelectTrigger } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-resolve-variant-config-dialog',
  imports: [CommonModule, MatDialogModule, ReactiveFormsModule, FormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule,
            MatProgressSpinnerModule, MatCardModule],
  standalone: true,
  providers: [
    TeamService
  ],
  templateUrl: './resolve-variant-config-dialog.component.html',
  styleUrl: './resolve-variant-config-dialog.component.scss'
})

export class ResolveVariantConfigDialogComponent implements OnInit {
  protected svc_Team = inject(TeamService);

  fg_VariantConfig: FormGroup = <FormGroup>{};
  teamVariantList: TeamVariant[] = [];
  modelVariantList: ModelVariant[] = [];
  selectedModelsList: string[] = [];
  selectedModelVariants: ModelVariant[] = [];
  baseVariant: TeamVariant = <TeamVariant>{}
  isBusy: boolean = false;
  
  constructor(
    public dialogRef: MatDialogRef<ResolveVariantConfigDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResolveData,
    private fb: FormBuilder ) {}
    

  ngOnInit(): void {
    this.getTeamVariants();

    this.fg_VariantConfig = this.fb.group({
      f_ModelVariants: new FormControl([])
    });

    this.fg_VariantConfig.get('f_ModelVariants')!.valueChanges.subscribe((value)=>{
      this.selectedModelVariants = value;
      this.selectedModelsList = this.selectedModelVariants.map(model => model.model_name);
    });
    

    console.debug('Data from pitch-dialog:', this.data)
    let baseIndex = this.data.variant_list.findIndex(variant => variant.base_variant_id == 1)
    if (baseIndex != -1){
      this.baseVariant = this.data.variant_list[baseIndex]
    }

    console.debug('Base Variant:', this.baseVariant)
  }

  onNoClick():void{
    this.dialogRef.close()
  }

  getTeamVariants(){
    // get a list of team variants that have already been defined for the team
    this.svc_Team.getTeamVariant(this.data.team_id, this.data.version_id).subscribe(out=>{
      this.teamVariantList = out.Body;
      let baseIndex = this.teamVariantList.findIndex(variant => variant.base_variant_id == 1)
      this.svc_Team.getModelVariant(this.data.team_id).subscribe(out=>{
        this.modelVariantList = out.Body;

        if (baseIndex != -1){
          this.teamVariantList[baseIndex].model_variants?.forEach(model =>{
            this.modelVariantList = this.modelVariantList.filter(variant=>variant.model_id != model.model_id)
          });
        }

        console.debug('Model Variants:', this.modelVariantList)
        console.debug('Model Variants:', this.teamVariantList)
      });
    })
  }


  onSubmit(){this.isBusy = true;
    // if disableModelSelection == true then an existing variant has been chosen
    // if disableVariantSelection == true then model variants have been selected
    let teamVariantName = this.selectedModelVariants.map(model => model.model_name.trim()).join('/');

    if (teamVariantName !== ''){
    const compareVariant = async() =>{
      const variantCompared: any = await this.compareToTeamVariants();
      return variantCompared; 
    };

    compareVariant().then((response)=>{
      console.debug('Compare Variant Response:', response)
      if (response.variant_id === 0){
        console.debug('New variant.')
        this.svc_Team.createTeamVariant(this.data.team_id, teamVariantName, this.selectedModelVariants)
        .subscribe((out)=>{
          let newVariantID = out.Body['VARIANTID'];
          this.svc_Team.transferPitchWork(this.data.plant_name, this.data.team_id, this.data.version_id, 
            this.data.pitch_config_id, this.baseVariant.variant_id, this.data.pitch_config_id, newVariantID)
            .subscribe(out=>{
              this.isBusy = false;
              this.dialogRef.close({ variant: {variant_id: newVariantID, variant_name: teamVariantName, model_variants: this.selectedModelVariants }, removeBase: this.baseVariant });
          });
        });
      } else {
        console.debug('Found matching variant.')
        this.svc_Team.transferPitchWork(this.data.plant_name, this.data.team_id, this.data.version_id, 
            this.data.pitch_config_id, this.baseVariant.variant_id, this.data.pitch_config_id, response.variant_id)
            .subscribe(out=>{
              this.isBusy = false;
              this.dialogRef.close({ variant: response, removeBase: this.baseVariant });
          });
      }
    });
    } else {
      this.isBusy = false;
      this.dialogRef.close({removeBase: this.baseVariant});
    }
  }

  compareToTeamVariants():TeamVariant{
    console.debug('Selected Model Variants:', this.selectedModelVariants)
    let existingVariant: TeamVariant = { variant_id: 0, variant_name: '', model_variants:[] };
    let sModelVariants: any[] = [];

    this.teamVariantList.forEach(variant=>{
      sModelVariants = this.selectedModelVariants.map((model)=> { return { model_id: model.model_id, model_name: model.model_name }; });
      
      if (variant.model_variants!=undefined && sModelVariants != undefined){
        if (compareArrays(variant.model_variants, sModelVariants) ){
          console.debug('Matching Variant:', variant)
          existingVariant = variant
        }
      }
    });

    return existingVariant;
  }

}

function compareArrays (arr1: ModelVariant[], arr2: ModelVariant[]) {
  let noMatch: boolean = true;
  
  if(arr1.length !== arr2.length){
    console.debug('False because of length.')
    return false;
  }

  arr1.forEach(model =>{
    if (!arr2.some(value=> value.model_id === model.model_id) && (noMatch)){
      console.debug('False because a value was not found', arr2, model.model_id, arr2.some(value=> value.model_id === model.model_id), noMatch)
      noMatch = false;
    }
  })

  return noMatch;
}

export interface ResolveData {
  plant_name: string;
  team_id: number;
  version_id: number;
  pitch_config_id: number;
  variant_list: TeamVariant[];
}
